import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// One shared /market/areas request per page load (used by the page shell, MarketWidgets and AreaCompare).
let _areasPromise = null;
export function fetchAreas() {
  if (!_areasPromise) {
    _areasPromise = api.get("/market/areas")
      .then((r) => (Array.isArray(r.data) ? r.data : []))
      .catch((e) => { _areasPromise = null; throw e; });
  }
  return _areasPromise;
}

export const toSlug = (name) => (name || "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const findAreaBySlug = (areas, slug) => {
  if (!slug || !areas || !areas.length) return null;
  const s = slug.toLowerCase();
  return areas.find((a) => toSlug(a.area) === s) || null;
};

// Resolves a /dubai-compare-areas/:pair param; null when either side is unknown.
export const resolvePair = (areas, pair) => {
  const parts = (pair || "").split("-vs-");
  if (parts.length !== 2) return null;
  const a = findAreaBySlug(areas, parts[0]);
  const b = findAreaBySlug(areas, parts[1]);
  return a && b ? [a, b] : null;
};

// { areas, loaded, failed } — failed distinguishes an API error from "no such slug".
export function useMarketAreas() {
  const [state, setState] = useState({ areas: [], loaded: false, failed: false });
  useEffect(() => {
    let live = true;
    fetchAreas()
      .then((areas) => live && setState({ areas, loaded: true, failed: false }))
      .catch(() => live && setState({ areas: [], loaded: true, failed: true }));
    return () => { live = false; };
  }, []);
  return state;
}

export const AREA_EVENT = "propertic:area-selected";
export const PAIR_EVENT = "propertic:pair-selected";
